export const USER_TOKEN = "token";
export const REFRESH_TOKEN = "refresh_token";
export const USER_ID = "user_id";
export const ORG_ID = "org_id";
export const AUTHORIZATION = "Authorization";
export const API_KEY = "SixPillarsApiKey";
export const BEARER = "Bearer";
